<div class="animated fadeIn">

<div class="row">
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body" style="min-height: 600px;">

                <div class="row" >
                    <div class="col col-md-12">
                        <div class="card border border-success">
                            <div class="card-header">
                                
                                <div class="row">
                                    <div class="col col-md-2">
                                        <strong class="card-title">User Search</strong>
                                    </div>
                                    <div class="col col-md-2">
                                        <select name="userRole" id="userRole" class="form-control-sm form-control" [(ngModel)]="userRole">
                                            <option  value="">Select Role</option>
                                            <option value="1">Admin</option>
                                            <option value="2">Analyst</option>   
                                            <option value="3">CEO</option>
                                            <option value="4">Compliance</option>
                                        </select>
                                    </div>
                                    <div class="col col-md-2">
                                        <input name="companyName" [(ngModel)]="companyName" placeholder="Company" id="companyName" class="form-control-sm form-control"  />
                                    </div>
                                    <div class="col col-md-2">
                                        <input name="email" [(ngModel)]="email" id="email" placeholder="User Email" class="form-control-sm form-control"  />
                                    </div>
                                    <div class="col col-md-2">
                                        <input name="username" [(ngModel)]="username" id="username" placeholder="User ID" class="form-control-sm form-control"  />
                                    </div>
                                    <div class="col col-md-2">
                                        <button type="submit" class="btn btn-primary btn-sm" (click)="searchUser(1)" >Search</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <table id="bootstrap-data-table" class="table table-striped table-bordered dataTable no-footer" role="grid" aria-describedby="bootstrap-data-table_info">
                                            <thead>
                                                <tr role="row">
                                                    <th style="width: 15%;">Role</th>
                                                    <th style="width: 15%;">Company</th>
                                                    <th style="width: 20%;">Email</th>
                                                    <th style="width: 15%;">User ID</th>
                                                    <th style="width: 15%;">Status</th>
                                                    <th style="width: 20%;">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody> 
                                            <tr role="row" class="odd" *ngFor="let fdata of fileData">
                                                <td style="width: 15%;">{{ fdata.roleName }}</td>
                                                <td style="width: 15%;">{{ fdata.companyCode?fdata.companyCode:"N/A"}}</td>
                                                <td style="word-wrap: break-word">{{ fdata.email}}</td>
                                                <td style="width: 15%;">{{ fdata.username}}</td>
                                                <td style="width: 15%;">{{ fdata.status=="1" ?"Active":"Inactive"}}</td>
                                               <td style="width: 20%;"><a  class="btn" (click)="userDelete(fdata.userId)"><i class="fa fa-trash"></i></a>
                                               <a  class="btn" style="margin-left: 5px;" (click)="gotoEditPage(fdata.userId)"><i class="fa fa-pencil"></i></a>
                                               <a  class="btn" style="margin-left: 5px;" (click)="gotoAuditPage(fdata.userId)"><i class="fa fa-history"></i></a>
                                               </td>
                                            </tr> 
                                            <!--<tr role="row" class="odd" *ngIf="haveData">
                                                <td colspan="5"> NO DATA FOUND
                                               </td>
                                            </tr> -->
                                            
                                        </tbody>
                                        </table>
            </div>
        </div>
       <div class="row">
                                    <div class="col-sm-12 col-md-5">
                                        <div class="dataTables_info" id="bootstrap-data-table_info" role="status" aria-live="polite">Showing {{(curPage-1)*perPageRow+1}} to {{(curPage-1)*perPageRow+noOfRows}} of {{totalRows}}</div>
                                    </div>
                                    <div class="col-sm-12 col-md-7">
                                        <div class="dataTables_paginate paging_simple_numbers" id="bootstrap-data-table_paginate">
                                            <ul class="pagination">
                                               <!-- <li class="paginate_button page-item previous disabled" id="bootstrap-data-table_previous" (click)="searchFile(curPage-1)" *ngIf="curPage==1">
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                                </li>-->
                                                
                                                <li class="paginate_button page-item {{item==curPage?'active':''}}" *ngFor="let item of pages; let i = index" (click)="searchUser(item)">
                                                    <a  aria-controls="bootstrap-data-table"  class="page-link">{{item}}</a>
                                                </li>
                                                <!--<li class="paginate_button page-item next" id="bootstrap-data-table_next" (click)="searchFile(curPage-1)" >
                                                    <a  aria-controls="bootstrap-data-table" data-dt-idx="7" tabindex="0" class="page-link">Next</a>
                                                </li>-->
                                            </ul>
                                        </div>
                                    </div>
                                </div>
    </div>

</div>
</div><!-- .animated -->

